module.exports = __webpack_public_path__ + "img/pai.971e384f.png";